/*
 * LEEVJE – CART DRAWER SHOP THE LOOK V8.0.3
 * Mehrere Looks swipebar + gemeinsamer Produktbereich.
 * Nach erfolgreichem Hinzufügen wird Shop the Look für den
 * aktuellen Warenkorb-Dialog komplett ausgeblendet.
 *
 * V8:
 * - Ausverkaufte Produkte werden nicht angezeigt.
 * - Produkte mit ed_lv.coming_soon == true werden nicht angezeigt.
 * - Coming-Soon wird serverseitig über den Eligibility-Marker
 *   in sections/cart-drawer.liquid geprüft.
 */
(function () {
  'use strict';

  if (window.LeevjeCartLook && window.LeevjeCartLook.version === '8.0.3') {
    return;
  }

  var API = { version: '8.0.3' };
  window.LeevjeCartLook = API;

  var observer = null;
  var initTimer = null;
  var eligibilityCache = new Map();
  var dismissedCartSignature = null;

  function shopRoot() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    return '/';
  }

  function endpoint(path) {
    var root = shopRoot();
    if (root.charAt(root.length - 1) !== '/') root += '/';
    return root + path.replace(/^\/+/, '');
  }

  function normalize(value) {
    return String(value || '').trim().toLowerCase();
  }

  function pad(value) {
    return String(value).padStart(2, '0');
  }

  async function fetchJson(url, options) {
    var response = await fetch(url, options || {});

    if (!response.ok) {
      var payload = {};
      try {
        payload = await response.json();
      } catch (e) {}

      throw new Error(
        payload.description ||
        payload.message ||
        'Request fehlgeschlagen.'
      );
    }

    return response.json();
  }

  function getCart() {
    return fetchJson(endpoint('cart.js'), {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    });
  }

  function cartProductHandles(cart) {
    var set = new Set();

    (cart.items || []).forEach(function (item) {
      if (item.handle) set.add(normalize(item.handle));
    });

    return set;
  }

  function cartProductIds(cart) {
    var set = new Set();

    (cart.items || []).forEach(function (item) {
      if (item.product_id != null) {
        set.add(String(item.product_id));
      }
    });

    return set;
  }

  function cartSignature(cart) {
    return (cart && Array.isArray(cart.items) ? cart.items : [])
      .map(function (item) {
        return [
          item.key || '',
          item.product_id || '',
          item.variant_id || '',
          item.quantity || 0
        ].join(':');
      })
      .sort()
      .join('|');
  }

  function getSizeOptionIndex(productData) {
    var names = (productData.options || []).map(function (option) {
      return normalize(
        typeof option === 'string'
          ? option
          : (option && option.name)
      );
    });

    return names.findIndex(function (name) {
      return (
        name === 'größe' ||
        name === 'groesse' ||
        name === 'size' ||
        name.indexOf('größe') !== -1 ||
        name.indexOf('groesse') !== -1 ||
        name.indexOf('size') !== -1
      );
    });
  }

  function firstAvailableVariant(productData) {
    return (productData.variants || []).find(function (variant) {
      return variant.available;
    }) || null;
  }

  function variantForSize(productData, sizeIndex, value) {
    return (productData.variants || []).find(function (variant) {
      return (
        String(variant.options[sizeIndex]) === String(value) &&
        variant.available
      );
    }) || null;
  }

  function buildSizeOptions(productData, sizeIndex, select) {
    var seen = new Set();

    (productData.variants || []).forEach(function (variant) {
      var value = variant.options[sizeIndex];
      var token = String(value);

      if (seen.has(token)) return;
      seen.add(token);

      var available = (productData.variants || []).some(function (candidate) {
        return (
          String(candidate.options[sizeIndex]) === token &&
          candidate.available
        );
      });

      var option = document.createElement('option');
      option.value = value;
      option.textContent = available
        ? value
        : value + ' – ausverkauft';
      option.disabled = !available;

      select.appendChild(option);
    });
  }

  function formatMoney(cents, currency) {
    try {
      return new Intl.NumberFormat(
        document.documentElement.lang || 'de-DE',
        {
          style: 'currency',
          currency: currency || 'EUR'
        }
      ).format(Number(cents || 0) / 100);
    } catch (error) {
      return (
        (Number(cents || 0) / 100).toFixed(2) +
        ' ' +
        (currency || 'EUR')
      );
    }
  }

  async function searchProductsByTag(tag) {
    var url =
      endpoint('search/suggest.json') +
      '?q=' + encodeURIComponent('tag:' + tag) +
      '&resources[type]=product' +
      '&resources[limit]=10' +
      '&resources[options][unavailable_products]=hide';

    var data = await fetchJson(url, {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    });

    return (
      data &&
      data.resources &&
      data.resources.results &&
      Array.isArray(data.resources.results.products)
    )
      ? data.resources.results.products
      : [];
  }

  function getProduct(handle) {
    return fetchJson(
      endpoint('products/' + encodeURIComponent(handle) + '.js'),
      {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      }
    );
  }

  async function getEligibility(handle) {
    var key = normalize(handle);

    if (eligibilityCache.has(key)) {
      return eligibilityCache.get(key);
    }

    var url =
      endpoint('products/' + encodeURIComponent(handle)) +
      '?section_id=cart-drawer&lv_eligibility=1';

    var response = await fetch(url, {
      headers: {
        Accept: 'text/html',
        'X-Requested-With': 'XMLHttpRequest'
      },
      credentials: 'same-origin'
    });

    if (!response.ok) {
      throw new Error('Produktstatus konnte nicht geprüft werden.');
    }

    var html = await response.text();
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var marker = doc.querySelector('[data-lv-product-eligibility]');

    var result = {
      markerFound: !!marker,

      available:
        !marker ||
        marker.getAttribute('data-product-available') === 'true',

      comingSoon:
        !!marker &&
        marker.getAttribute('data-product-coming-soon') === 'true'
    };

    eligibilityCache.set(key, result);
    return result;
  }

  async function getEligibleProduct(handle) {
    var results = await Promise.all([
      getProduct(handle),
      getEligibility(handle)
    ]);

    var product = results[0];
    var eligibility = results[1];

    var hasAvailableVariant = (product.variants || []).some(function (variant) {
      return variant.available;
    });

    if (
      !eligibility.available ||
      eligibility.comingSoon ||
      !hasAvailableVariant
    ) {
      return null;
    }

    return product;
  }

  function ensureStyles() {
    if (document.getElementById('leevje-cart-look-global-styles-v8')) {
      return;
    }

    var old = document.getElementById('leevje-cart-look-global-styles-v7');
    if (old) old.remove();

    var style = document.createElement('style');
    style.id = 'leevje-cart-look-global-styles-v8';

    style.textContent = `
      .lv-cart-look {
        margin-top: 12px;
        padding: 18px 0 6px;
        border-top: 1px solid rgba(41,38,33,.12);
        border-bottom: 1px solid rgba(41,38,33,.12);
        color: #292621;
      }

      .lv-cart-look,
      .lv-cart-look * {
        box-sizing: border-box;
      }

      .lv-cart-look__heading {
        display: grid;
        gap: 5px;
        margin-bottom: 14px;
      }

      .lv-cart-look__eyebrow {
        color: #b58b66;
        font-size: 8px;
        line-height: 1.2;
        font-weight: 700;
        letter-spacing: .17em;
        text-transform: uppercase;
      }

      .lv-cart-look__heading strong {
        font-size: 19px;
        line-height: 1.15;
        font-weight: 400;
      }

      .lv-cart-look__heading p {
        margin: 0;
        color: #716a61;
        font-size: 10.5px;
        line-height: 1.45;
      }

      .lv-cart-look__carousel-wrap {
        position: relative;
      }

      .lv-cart-look__carousel {
        overflow-x: auto;
        overflow-y: hidden;
        scrollbar-width: none;
        scroll-snap-type: x mandatory;
        -webkit-overflow-scrolling: touch;
      }

      .lv-cart-look__carousel::-webkit-scrollbar {
        display: none;
      }

      .lv-cart-look__track {
        display: flex;
        gap: 10px;
        width: max-content;
      }

      .lv-cart-look__slide {
        flex: 0 0 min(82vw, 390px);
        width: min(82vw, 390px);
        scroll-snap-align: start;
        opacity: .55;
        transition: opacity .2s ease;
      }

      .lv-cart-look__slide.is-active {
        opacity: 1;
      }

      .lv-cart-look__hero {
        position: relative;
        width: 100%;
        height: 132px;
        overflow: hidden;
        background: #f5f1ea;
      }

      .lv-cart-look__hero-image {
        display: block !important;
        width: 100% !important;
        height: 100% !important;
        min-height: 0 !important;
        object-fit: cover !important;
        object-position: center 46% !important;
      }

      .lv-cart-look__number {
        position: absolute;
        top: 10px;
        left: 11px;
        color: #fff;
        font-size: 11px;
        letter-spacing: .10em;
        text-shadow: 0 1px 8px rgba(0,0,0,.18);
      }

      .lv-cart-look__slide-copy {
        display: grid;
        gap: 2px;
        padding-top: 9px;
      }

      .lv-cart-look__slide-copy strong {
        font-size: 13px;
        line-height: 1.3;
        font-weight: 500;
      }

      .lv-cart-look__slide-copy span {
        color: #716a61;
        font-size: 9.5px;
        line-height: 1.3;
      }

      .lv-cart-look__nav {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 10px;
      }

      .lv-cart-look__counter {
        display: flex;
        align-items: center;
        gap: 8px;
        color: #716a61;
        font-size: 9px;
        letter-spacing: .08em;
      }

      .lv-cart-look__counter strong {
        color: #b58b66;
        font-weight: 600;
      }

      .lv-cart-look__counter > span:nth-child(2) {
        width: 28px;
        height: 1px;
        background: #c9b8aa;
      }

      .lv-cart-look__arrows {
        display: flex;
        gap: 7px;
      }

      .lv-cart-look__arrows button {
        display: grid;
        place-items: center;
        width: 32px;
        height: 32px;
        padding: 0;
        border: 1px solid #ddd3c9;
        border-radius: 50%;
        background: transparent;
        color: #292621;
        font-size: 14px;
      }

      .lv-cart-look__active-panel {
        margin-top: 14px;
        padding-top: 13px;
        border-top: 1px solid rgba(41,38,33,.10);
      }

      .lv-cart-look__panel-head {
        display: grid;
        gap: 3px;
        margin-bottom: 5px;
      }

      .lv-cart-look__panel-head span {
        color: #9a8e82;
        font-size: 7.5px;
        font-weight: 600;
        letter-spacing: .12em;
        text-transform: uppercase;
      }

      .lv-cart-look__panel-head strong {
        font-size: 12px;
        font-weight: 500;
      }

      .lv-cart-look__loading,
      .lv-cart-look__feedback {
        margin: 0;
        padding: 5px 0 8px;
        color: #716a61;
        font-size: 9.5px;
      }

      .lv-cart-look-product {
        display: grid !important;
        grid-template-columns: 22px 64px minmax(0,1fr) !important;
        gap: 10px !important;
        align-items: start !important;
        padding: 11px 0 !important;
        border-top: 1px solid rgba(41,38,33,.09);
      }

      .lv-cart-look-product.is-disabled {
        opacity: .46;
      }

      .lv-cart-look-product__select {
        position: relative;
        display: block;
        width: 20px;
        height: 20px;
        margin-top: 3px;
      }

      .lv-cart-look-product__select input {
        position: absolute !important;
        width: 1px !important;
        height: 1px !important;
        opacity: 0 !important;
      }

      .lv-cart-look-product__check {
        position: relative;
        display: block;
        width: 20px;
        height: 20px;
        border: 1px solid #b9afa5;
        border-radius: 50%;
        background: #fff;
      }

      .lv-cart-look-product__select input:checked + .lv-cart-look-product__check {
        border-color: #b58b66;
        background: #eee4d8;
      }

      .lv-cart-look-product__select input:checked + .lv-cart-look-product__check::after {
        content: "";
        position: absolute;
        left: 6px;
        top: 3px;
        width: 5px;
        height: 9px;
        border-right: 1.5px solid #7b5e46;
        border-bottom: 1.5px solid #7b5e46;
        transform: rotate(42deg);
      }

      .lv-cart-look-product__image-link {
        display: block;
        width: 64px;
        height: 80px;
        overflow: hidden;
      }

      .lv-cart-look-product__image {
        display: block !important;
        width: 64px !important;
        height: 80px !important;
        object-fit: cover !important;
        background: #f7f4f0;
      }

      .lv-cart-look-product__body {
        min-width: 0;
      }

      .lv-cart-look-product__title {
        display: -webkit-box;
        overflow: hidden;
        color: #292621 !important;
        font-size: 10.5px !important;
        line-height: 1.32 !important;
        font-weight: 500 !important;
        text-decoration: none !important;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }

      .lv-cart-look-product__price {
        margin-top: 3px;
        color: #716a61;
        font-size: 9.5px;
      }

      .lv-cart-look-product__actions {
        display: grid !important;
        grid-template-columns: minmax(0,1fr) auto;
        gap: 8px;
        align-items: end;
        margin-top: 7px;
      }

      .lv-cart-look-product__size-wrap {
        display: grid;
        gap: 4px;
      }

      .lv-cart-look-product__size-wrap > span {
        color: #8c8379;
        font-size: 7px;
        font-weight: 600;
        letter-spacing: .12em;
      }

      .lv-cart-look-product__size {
        display: block !important;
        width: 100% !important;
        height: 34px !important;
        padding: 0 28px 0 9px !important;
        border: 1px solid #d1c8be !important;
        border-radius: 0 !important;
        background: #fff !important;
        color: #292621 !important;
        font-size: 9.5px !important;
      }

      .lv-cart-look-product__view {
        display: inline-flex;
        align-items: center;
        min-height: 34px;
        color: #716a61 !important;
        font-size: 7.5px !important;
        font-weight: 600;
        letter-spacing: .08em;
        text-decoration: underline !important;
        text-underline-offset: 3px;
        white-space: nowrap;
      }

      .lv-cart-look-product__note {
        margin: 5px 0 0;
        color: #9b3d35;
        font-size: 8.5px;
      }

      .lv-cart-look__bulk {
        padding: 12px 0 2px;
        border-top: 1px solid rgba(41,38,33,.10);
      }

      .lv-cart-look__bulk-meta {
        display: flex;
        justify-content: space-between;
        gap: 10px;
        margin-bottom: 8px;
        color: #716a61;
        font-size: 8.5px;
      }

      .lv-cart-look__bulk-add {
        display: flex !important;
        align-items: center;
        justify-content: center;
        width: 100% !important;
        min-height: 46px !important;
        border: 0 !important;
        border-radius: 0 !important;
        background: #292621 !important;
        color: #fff !important;
        font-size: 8.5px !important;
        font-weight: 500;
        letter-spacing: .13em;
        text-transform: uppercase;
      }

      .lv-cart-look__bulk-add:disabled {
        opacity: .32 !important;
      }

      @media screen and (max-width:749px) {
        .lv-cart-look__slide {
          flex-basis: calc(100vw - 92px);
          width: calc(100vw - 92px);
          max-width: 360px;
        }

        .lv-cart-look__hero {
          height: 118px;
        }

        .lv-cart-look-product {
          grid-template-columns: 20px 60px minmax(0,1fr) !important;
          gap: 9px !important;
        }

        .lv-cart-look-product__image-link,
        .lv-cart-look-product__image {
          width: 60px !important;
          height: 75px !important;
        }
      }
    `;

    document.head.appendChild(style);
  }

  function setFeedback(root, text) {
    var node = root.querySelector('[data-lv-cart-look-feedback]');
    if (node) node.textContent = text || '';
  }

  function setLoading(root, loading) {
    var node = root.querySelector('[data-lv-cart-look-loading]');
    if (node) node.hidden = !loading;
  }

  function updateSelectionState(root) {
    var cards = Array.prototype.slice.call(
      root.querySelectorAll('[data-lv-cart-product-card]')
    );

    var selected = 0;
    var missing = 0;

    cards.forEach(function (card) {
      var checkbox = card.querySelector('[data-lv-cart-product-enabled]');

      if (!checkbox || !checkbox.checked || checkbox.disabled) return;

      selected += 1;
      if (!card.dataset.lvVariantId) missing += 1;
    });

    var bulk = root.querySelector('[data-lv-cart-look-bulk]');
    var button = root.querySelector('[data-lv-cart-add-selected]');
    var count = root.querySelector('[data-lv-cart-selected-count]');
    var note = root.querySelector('[data-lv-cart-selection-note]');

    if (bulk) bulk.hidden = cards.length === 0;

    if (count) {
      count.textContent =
        selected === 1
          ? '1 Artikel ausgewählt'
          : selected + ' Artikel ausgewählt';
    }

    if (note) {
      if (!selected) {
        note.textContent = 'Bitte auswählen';
      } else if (missing === 1) {
        note.textContent = 'Noch 1 Größe wählen';
      } else if (missing > 1) {
        note.textContent = 'Noch ' + missing + ' Größen wählen';
      } else {
        note.textContent = 'Bereit';
      }
    }

    if (button) button.disabled = selected === 0;
  }

  function renderProduct(root, template, productData, currency) {
    var fragment = template.content.cloneNode(true);
    var card = fragment.querySelector('[data-lv-cart-product-card]');
    var checkbox = fragment.querySelector('[data-lv-cart-product-enabled]');
    var image = fragment.querySelector('[data-lv-cart-product-image]');
    var imageLink = fragment.querySelector('[data-lv-cart-product-link]');
    var title = fragment.querySelector('[data-lv-cart-product-title]');
    var view = fragment.querySelector('[data-lv-cart-product-view]');
    var price = fragment.querySelector('[data-lv-cart-product-price]');
    var select = fragment.querySelector('[data-lv-cart-size-select]');
    var note = fragment.querySelector('[data-lv-cart-product-note]');
    var sizeWrap = select
      ? select.closest('.lv-cart-look-product__size-wrap')
      : null;

    var productUrl = endpoint('products/' + productData.handle);
    var featured =
      productData.featured_image ||
      ((productData.images || [])[0] || '');

    title.textContent = productData.title || '';
    title.href = productUrl;

    if (imageLink) imageLink.href = productUrl;
    if (view) view.href = productUrl;

    if (image && featured) {
      image.src = featured;
      image.alt = productData.title || '';
    } else if (imageLink) {
      imageLink.style.display = 'none';
    }

    var available = (productData.variants || []).filter(function (variant) {
      return variant.available;
    });

    if (!available.length) {
      return null;
    }

    var prices = available.map(function (variant) {
      return Number(variant.price || 0);
    });

    var min = Math.min.apply(null, prices);
    var max = Math.max.apply(null, prices);

    if (price) {
      price.textContent =
        min === max
          ? formatMoney(min, currency)
          : 'ab ' + formatMoney(min, currency);
    }

    var sizeIndex = getSizeOptionIndex(productData);

    if (sizeIndex > -1) {
      buildSizeOptions(productData, sizeIndex, select);

      select.addEventListener('change', function () {
        var variant = select.value
          ? variantForSize(productData, sizeIndex, select.value)
          : null;

        card.dataset.lvVariantId = variant
          ? String(variant.id)
          : '';

        if (
          variant &&
          note &&
          note.textContent === 'Bitte Größe wählen.'
        ) {
          note.hidden = true;
          note.textContent = '';
        }

        updateSelectionState(root);
      });
    } else {
      var standard = firstAvailableVariant(productData);

      card.dataset.lvVariantId = standard
        ? String(standard.id)
        : '';

      select.innerHTML = '<option value="default">Standard</option>';
      select.disabled = true;

      if (sizeWrap) {
        var label = sizeWrap.querySelector('span');
        if (label) label.textContent = 'VARIANTE';
      }
    }

    checkbox.addEventListener('change', function () {
      card.classList.toggle('is-disabled', !checkbox.checked);
      updateSelectionState(root);
    });

    return fragment;
  }

  function activeSlide(root) {
    var slides = Array.prototype.slice.call(
      root.querySelectorAll('[data-lv-cart-look]')
    );

    return (
      slides.find(function (slide) {
        return slide.classList.contains('is-active');
      }) ||
      slides[0] ||
      null
    );
  }

  function currentSlideIndex(root) {
    var slides = Array.prototype.slice.call(
      root.querySelectorAll('[data-lv-cart-look]')
    );

    var carousel = root.querySelector('[data-lv-look-carousel]');

    if (!slides.length || !carousel) return 0;

    var left = carousel.getBoundingClientRect().left;
    var best = 0;
    var distance = Infinity;

    slides.forEach(function (slide, index) {
      var d = Math.abs(
        slide.getBoundingClientRect().left - left
      );

      if (d < distance) {
        distance = d;
        best = index;
      }
    });

    return best;
  }

  async function loadSlide(root, slide, cart) {
    if (!slide) return;

    var tag = String(slide.dataset.lookTag || '').trim();
    var title = slide.dataset.lookTitle || '';

    var productsNode = root.querySelector(
      '[data-lv-cart-look-products]'
    );

    var panelTitle = root.querySelector(
      '[data-lv-active-look-title]'
    );

    var template = root.querySelector(
      '[data-lv-cart-look-product-template]'
    );

    var status = slide.querySelector(
      '[data-lv-cart-look-status]'
    );

    var bulk = root.querySelector(
      '[data-lv-cart-look-bulk]'
    );

    if (panelTitle) panelTitle.textContent = title;
    if (productsNode) productsNode.innerHTML = '';
    if (bulk) bulk.hidden = true;

    setFeedback(root, '');
    setLoading(root, true);

    try {
      var searchProducts = await searchProductsByTag(tag);
      var handles = cartProductHandles(cart);
      var ids = cartProductIds(cart);

      var missingSearch = searchProducts.filter(function (item) {
        var handle = normalize(item && item.handle);
        var id =
          item && item.id != null
            ? String(item.id)
            : '';

        return !(
          (handle && handles.has(handle)) ||
          (id && ids.has(id))
        );
      });

      var checkedProducts = await Promise.all(
        missingSearch.map(async function (item) {
          try {
            return await getEligibleProduct(item.handle);
          } catch (error) {
            if (console && console.error) {
              console.error(
                '[leevje-cart-look eligibility]',
                item.handle,
                error
              );
            }

            return null;
          }
        })
      );

      var products = checkedProducts.filter(Boolean);

      if (!products.length) {
        setLoading(root, false);

        if (status) {
          status.textContent = 'Aktuell keine weiteren Artikel verfügbar';
        }

        if (bulk) {
          bulk.hidden = true;
        }

        updateSelectionState(root);
        return;
      }

      if (status) {
        status.textContent =
          products.length === 1
            ? 'Noch 1 Artikel'
            : 'Noch ' + products.length + ' Artikel';
      }

      var currency =
        root.dataset.cartCurrency ||
        (cart && cart.currency) ||
        (
          window.Shopify &&
          window.Shopify.currency &&
          window.Shopify.currency.active
        ) ||
        'EUR';

      products.forEach(function (product) {
        var fragment = renderProduct(
          root,
          template,
          product,
          currency
        );

        if (fragment && productsNode) {
          productsNode.appendChild(fragment);
        }
      });

      setLoading(root, false);

      if (bulk) bulk.hidden = false;

      updateSelectionState(root);
    } catch (error) {
      setLoading(root, false);

      setFeedback(
        root,
        error && error.message
          ? error.message
          : 'Der Look konnte nicht geladen werden.'
      );

      if (console && console.error) {
        console.error('[leevje-cart-look]', error);
      }
    }
  }

  async function activateAfterSlideRemoval(root, cart) {
    var slides = Array.prototype.slice.call(
      root.querySelectorAll('[data-lv-cart-look]')
    );

    if (!slides.length) {
      root.hidden = true;
      return;
    }

    slides.forEach(function (slide, index) {
      slide.classList.toggle('is-active', index === 0);
    });

    updateNav(root);
    await loadSlide(root, slides[0], cart);
  }

  function updateNav(root) {
    var slides = Array.prototype.slice.call(
      root.querySelectorAll('[data-lv-cart-look]')
    );

    var nav = root.querySelector('[data-lv-look-nav]');
    var current = root.querySelector('[data-lv-look-current]');
    var total = root.querySelector('[data-lv-look-total]');
    var index = currentSlideIndex(root);

    if (nav) nav.hidden = slides.length <= 1;
    if (current) current.textContent = pad(index + 1);
    if (total) total.textContent = pad(slides.length);

    slides.forEach(function (slide, i) {
      slide.classList.toggle('is-active', i === index);
    });
  }

  function scrollToSlide(root, index) {
    var slides = Array.prototype.slice.call(
      root.querySelectorAll('[data-lv-cart-look]')
    );

    var carousel = root.querySelector('[data-lv-look-carousel]');

    if (!slides.length || !carousel) return;

    var target = Math.max(
      0,
      Math.min(slides.length - 1, index)
    );

    carousel.scrollTo({
      left: slides[target].offsetLeft,
      behavior: 'smooth'
    });
  }

  function dismissLookAreaForCart(cart) {
    dismissedCartSignature = cartSignature(cart) || null;
  }

  function isLookAreaDismissed(cart) {
    var currentSignature = cartSignature(cart);

    if (
      dismissedCartSignature &&
      dismissedCartSignature !== currentSignature
    ) {
      dismissedCartSignature = null;
    }

    return (
      !!dismissedCartSignature &&
      dismissedCartSignature === currentSignature
    );
  }

  async function addSelected(root, cart) {
    var cards = Array.prototype.slice.call(
      root.querySelectorAll('[data-lv-cart-product-card]')
    );

    var items = [];
    var firstMissing = null;

    cards.forEach(function (card) {
      var checkbox = card.querySelector(
        '[data-lv-cart-product-enabled]'
      );

      if (
        !checkbox ||
        !checkbox.checked ||
        checkbox.disabled
      ) {
        return;
      }

      var variantId =
        card.dataset.lvVariantId || '';

      if (!variantId) {
        var note = card.querySelector(
          '[data-lv-cart-product-note]'
        );

        if (note) {
          note.hidden = false;
          note.textContent = 'Bitte Größe wählen.';
        }

        if (!firstMissing) {
          firstMissing = card.querySelector(
            '[data-lv-cart-size-select]'
          );
        }

        return;
      }

      items.push({
        id: Number(variantId),
        quantity: 1
      });
    });

    if (firstMissing) {
      setFeedback(
        root,
        'Bitte wähle zuerst die fehlende Größe.'
      );

      firstMissing.focus();

      firstMissing.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest'
      });

      return;
    }

    if (!items.length) return;

    var button = root.querySelector(
      '[data-lv-cart-add-selected]'
    );

    if (button) {
      button.disabled = true;
      button.textContent = 'WIRD HINZUGEFÜGT …';
    }

    setFeedback(root, '');

    try {
      await fetchJson(endpoint('cart/add.js'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify({
          items: items
        })
      });

      var freshCart = await getCart();

      dismissLookAreaForCart(freshCart);

      await refreshCartDrawerSection();

      dispatchCartState(freshCart);
    } catch (error) {
      setFeedback(
        root,
        error && error.message
          ? error.message
          : 'Bitte versuche es erneut.'
      );

      if (button) {
        button.disabled = false;
        button.textContent =
          'AUSGEWÄHLTE ARTIKEL HINZUFÜGEN';
      }
    }
  }

  function dispatchCartState(cart) {
    var detail = {
      cart: cart,
      baseEvent: 'variant:add'
    };

    [
      document,
      document.documentElement,
      window
    ].forEach(function (target) {
      [
        'cart:change',
        'cart:update',
        'cart:updated',
        'cart:refresh'
      ].forEach(function (name) {
        try {
          target.dispatchEvent(
            new CustomEvent(name, {
              bubbles: true,
              detail: detail
            })
          );
        } catch (error) {}
      });
    });
  }

  function getCartDrawerSection() {
    var drawer = document.querySelector(
      '#cart-drawer, cart-drawer'
    );

    if (!drawer) return null;

    var section = drawer.closest('.shopify-section');

    if (!section || !section.id) {
      return {
        drawer: drawer,
        sectionId: 'cart-drawer'
      };
    }

    return {
      drawer: drawer,
      sectionId: section.id.replace(
        /^shopify-section-/,
        ''
      )
    };
  }

  async function refreshCartDrawerSection() {
    var current = getCartDrawerSection();

    if (!current) return false;

    var url = new URL(window.location.href);
    url.searchParams.set(
      'section_id',
      current.sectionId
    );

    var response = await fetch(
      url.toString(),
      {
        headers: {
          Accept: 'text/html'
        },
        credentials: 'same-origin'
      }
    );

    if (!response.ok) {
      throw new Error(
        'Warenkorb konnte nicht aktualisiert werden.'
      );
    }

    var html = await response.text();
    var doc = new DOMParser().parseFromString(
      html,
      'text/html'
    );

    var replacementSection = doc.getElementById(
      'shopify-section-' + current.sectionId
    );

    var replacementDrawer = replacementSection
      ? replacementSection.querySelector(
          '#cart-drawer, cart-drawer'
        )
      : doc.querySelector(
          '#cart-drawer, cart-drawer'
        );

    if (!replacementDrawer) return false;

    current.drawer.innerHTML =
      replacementDrawer.innerHTML;

    Array.prototype.slice
      .call(replacementDrawer.attributes)
      .forEach(function (attribute) {
        if (attribute.name !== 'id') {
          current.drawer.setAttribute(
            attribute.name,
            attribute.value
          );
        }
      });

    current.drawer.classList.remove(
      'drawer--center-body'
    );

    requestAnimationFrame(function () {
      initAll(true);
    });

    return true;
  }

  async function initRoot(root, force) {
    if (
      !root ||
      !document.documentElement.contains(root)
    ) {
      return;
    }

    var cart = await getCart();

    if (isLookAreaDismissed(cart)) {
      root.hidden = true;
      return;
    }

    var slides = Array.prototype.slice.call(
      root.querySelectorAll('[data-lv-cart-look]')
    );

    var carousel = root.querySelector(
      '[data-lv-look-carousel]'
    );

    var prev = root.querySelector(
      '[data-lv-look-prev]'
    );

    var next = root.querySelector(
      '[data-lv-look-next]'
    );

    var addButton = root.querySelector(
      '[data-lv-cart-add-selected]'
    );

    if (!slides.length) {
      root.hidden = true;
      return;
    }

    root.hidden = false;

    slides.forEach(function (slide, index) {
      slide.classList.toggle(
        'is-active',
        index === 0
      );
    });

    updateNav(root);

    if (root.dataset.lvCarouselBound !== 'true') {
      root.dataset.lvCarouselBound = 'true';

      var scrollTimer;

      if (carousel) {
        carousel.addEventListener(
          'scroll',
          function () {
            clearTimeout(scrollTimer);

            scrollTimer = setTimeout(
              async function () {
                var previous = activeSlide(root);

                updateNav(root);

                var current = activeSlide(root);

                if (
                  current &&
                  current !== previous
                ) {
                  await loadSlide(
                    root,
                    current,
                    await getCart()
                  );
                }
              },
              90
            );
          },
          { passive: true }
        );
      }

      if (prev) {
        prev.addEventListener(
          'click',
          function () {
            scrollToSlide(
              root,
              currentSlideIndex(root) - 1
            );
          }
        );
      }

      if (next) {
        next.addEventListener(
          'click',
          function () {
            scrollToSlide(
              root,
              currentSlideIndex(root) + 1
            );
          }
        );
      }

      if (addButton) {
        addButton.addEventListener(
          'click',
          function () {
            getCart()
              .then(function (freshCart) {
                return addSelected(
                  root,
                  freshCart
                );
              })
              .catch(function (error) {
                setFeedback(
                  root,
                  error.message ||
                    'Warenkorb konnte nicht gelesen werden.'
                );
              });
          }
        );
      }
    }

    await loadSlide(
      root,
      activeSlide(root),
      cart
    );
  }

  async function initAll(force) {
    ensureStyles();

    var roots = Array.prototype.slice.call(
      document.querySelectorAll(
        '[data-lv-cart-look-root]'
      )
    );

    await Promise.all(
      roots.map(function (root) {
        return initRoot(root, !!force);
      })
    );
  }

  function debounceInit(delay) {
    clearTimeout(initTimer);

    initTimer = setTimeout(
      function () {
        initAll(true);
      },
      typeof delay === 'number'
        ? delay
        : 100
    );
  }

  function bindGlobalEvents() {
    [
      'cart:refresh',
      'cart:change',
      'cart:update',
      'cart:updated',
      'variant:add'
    ].forEach(function (eventName) {
      document.addEventListener(
        eventName,
        function () {
          debounceInit(180);
        }
      );

      window.addEventListener(
        eventName,
        function () {
          debounceInit(180);
        }
      );
    });

    document.addEventListener(
      'shopify:section:load',
      function () {
        debounceInit(80);
      }
    );
  }

  function startObserver() {
    if (!document.body || observer) return;

    observer = new MutationObserver(
      function (mutations) {
        var shouldInit = false;

        mutations.forEach(function (mutation) {
          Array.prototype.slice
            .call(mutation.addedNodes || [])
            .forEach(function (node) {
              if (
                node &&
                node.nodeType === 1 &&
                (
                  (
                    node.matches &&
                    node.matches(
                      '[data-lv-cart-look-root], cart-drawer, #cart-drawer'
                    )
                  ) ||
                  (
                    node.querySelector &&
                    node.querySelector(
                      '[data-lv-cart-look-root], cart-drawer, #cart-drawer'
                    )
                  )
                )
              ) {
                shouldInit = true;
              }
            });
        });

        if (shouldInit) {
          debounceInit(120);
        }
      }
    );

    observer.observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );
  }

  function boot() {
    ensureStyles();
    bindGlobalEvents();
    startObserver();
    initAll(true);
  }

  API.init = function () {
    return initAll(true);
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      boot,
      { once: true }
    );
  } else {
    boot();
  }
})();
